import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumberYMD, plusDays, stringYMDHMS3 } from "../Utility/dateTime";
import TimeContainer from "./TimeContainer";
import { fetchShift, updateEndDate, updateShifts, updateStartDate } from "../redux/shiftSlice";



function TimeControlShift() {
    const dispatch = useDispatch()
    const { shop:{ shopId } } = useSelector((state)=> state.shop);

    const { billDates, modal_Shift, startDate, endDate } = useSelector((state)=> state.shift);

    useEffect(()=>{
        if(billDates.length===0){
            search()
        }
    },[])


    function search(){
        let rewSearch = []
        let newSearch = []
        let start = startDate
        do {
            rewSearch.push(stringYMDHMS3(start))
            start = plusDays(start,1)
        }
        while (NumberYMD(start) <= NumberYMD(endDate));

        for(const item of rewSearch){
            if(!billDates.includes(item)){
                newSearch.push(item)
            }
        }
        
        if(newSearch.length >0){ //มีต้อง fetch เพิ่ม
            dispatch(fetchShift({
                shopId,
                billDate:newSearch,
                selectedDate:rewSearch 
            }))
        } else {
            dispatch(updateShifts({ selectedDate:rewSearch }))
        }
    }

  return <TimeContainer
            search={search}
            show={modal_Shift}
            startDate={startDate}
            endDate={endDate}
            onChangeStart={(date) => dispatch(updateStartDate(date))}
            onChangeEnd={(date) => dispatch(updateEndDate(date))}
        />
};


export default TimeControlShift;
